const Dropdown = () => import('./Dropdown')
const ModalTrigger = () => import('./ModalTrigger')
const ClickOutside = () => import('./ClickOutside')
const Search = () => import('./Search')
const ScrollTopButton = () => import('./ScrollTopButton')
const Toggle = () => import('./Toggle')
const Cropper = () => import('./Cropper')
const Tabs = () => import('./Tabs')
const Uploader = () => import('./Uploader')
const BarcodeScanner = () => import('./BarcodeScanner')
const StickyHeader = () => import('./StickyHeader')

const Like = () => import('./Wishlists/Like')
const LikeCounter = () => import('./Wishlists/LikeCounter')

const SwitchMobileMenu = () => import('./Switchers/SwitchMobileMenu')

const FAQItem = () => import('./Accordions/FAQItem')
const ProductInfoItem = () => import('./Accordions/ProductInfoItem')

export default function install(Vue) {
  Vue.component('ui-dropdown', Dropdown)
  Vue.component('ui-modal-trigger', ModalTrigger)
  Vue.component('ui-click-outside', ClickOutside)
  Vue.component('ui-search', Search)
  Vue.component('ui-scroll-top-button', ScrollTopButton)
  Vue.component('ui-toggle', Toggle)
  Vue.component('ui-cropper', Cropper)
  Vue.component('ui-tabs', Tabs)
  Vue.component('ui-uploader', Uploader)
  Vue.component('ui-barcode-scanner', BarcodeScanner)
  Vue.component('ui-like-toggle', Like)
  Vue.component('ui-like-counter', LikeCounter)
  Vue.component('ui-switch-mobile-menu', SwitchMobileMenu)
  Vue.component('ui-faq-item', FAQItem)
  Vue.component('ui-product-info-item', ProductInfoItem)
  Vue.component('ui-sticky-header', StickyHeader)
}
